// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__15oTK","notes":"Notes_notes__3ojQS"};